/**
 * 全局注册自定义指令
 * @dec:循环遍历，进行全局注册
 */
import debounce from './debounce/index'
import limitInput from './limit-input/index'
import draggable from './draggable'
import scrollToTop from './scrollToTop'

const directives = {
  debounce,
  limitInput,
  draggable,
  scrollToTop
}

export default {
  install(Vue) {
    Object.keys(directives).forEach(key => {
      Vue.directive(key, directives[key])
    })
  }
}



// WEBPACK FOOTER //
// ./src/directive/index.js